// Curated whitelist of payment fields that can be requested by
// `exportPaymentsCsv`. Shared between the backend usecase (the SQL projection
// is keyed off this tuple) and the CRM frontend (multi-select). PII / PCI
// columns (raw PAN, CVV, BIN, expiry, customer email, addresses, raw
// request/response payloads, 3DS data) are intentionally not in the list and
// cannot be requested.
export const PAYMENT_CSV_FIELDS = [
  'id',
  'orderId',
  'customerName',
  'kind',
  'gateway',
  'createdAt',
  'status',
  'subStatus',
  'amount',
  'currency',
  'cardBrand',
  'cardLast4',
  'paymentMethod',
  'storeId',
  'chainIndex',
  'retryIndex',
  'reasonType',
] as const;

export type PaymentCsvField = (typeof PAYMENT_CSV_FIELDS)[number];

// Matches the CRM Payments table's primary columns:
// Order | Name | Kind | Gateway | Created At | Status | Amount | Currency | Card Type | Payment Method
export const PAYMENT_CSV_FIELDS_ESSENTIALS: readonly PaymentCsvField[] = [
  'orderId',
  'customerName',
  'kind',
  'gateway',
  'createdAt',
  'status',
  'amount',
  'currency',
  'cardBrand',
  'paymentMethod',
];
